<template>
    <div class="content_title" >
        <div class="content_title_wrapper" :style="titleStyle">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
  name: 'content-title',
  props: {
    justify: {
      type: String,
    },
  },
  computed: {
    titleStyle () {
      return {
        justifyContent: this.justify,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.content_title {
    display: flex;
    align-items: center;
    height: 36px;
    margin-bottom: 16px;
    font-size: 14px;

    .content_title_wrapper{
        flex:1;
        display: flex;
        align-items: center;
    }

    &:before{
        width: 5px;
        height: 24px;
        content: '';
        background: rgb(37, 119, 227);
        margin-right: 10px;
    }
}
</style>
